import { ChatAsideView } from "@/components/chat/ChatAsideView";

function Aside() {
  return (
    <aside className="h-full flex flex-col bg-background w-full">
      <ChatAsideView />
    </aside>
  );
}

export default Aside;
